module.exports = __webpack_public_path__ + "static/media/logo-sap-landscape-1.aac4b8c0.svg";